export default {"src":"/_next/static/image/public/images/ic_upload_white.0271064d360bc91c22435931b5830771.svg","height":16,"width":16};